<div class="event-log-container" [ngStyle]="{'minHeight': minHeight}">
    <app-table
        *ngIf="tOptionsSubject | async as tOptions"
        [rows]="tableRows"
        [options]="tOptions"
        (rowClickOutput)="handleRowClick($event)"
    ></app-table>
</div>

